import{Model} from 'ords/dist/model/model';

export class PersonalGoal extends Model{
    getPersonalGoalTasksStatuses(){
        let unfinished = 0;
        let finished = 0;
        let percentage = 0;

        if(this.tasks.length){
            for(const task of this.tasks){
                task.checked ? finished += 1 : unfinished += 1;
            }
        }

        if(this.tasks.length > 0 && finished > 0){
            percentage = Math.floor((finished / this.tasks.length) * 100)
        }

        return {
            unfinished,
            finished,
            percentage,
        }
    }

}

export const PersonalGoalsModelConfig = {
    name: 'personalGoal',
    model: PersonalGoal,
    relations: [
        {name: 'tasks', model_name: 'personalGoalsTask', returns_many: true, type: 'hasMany'},
        {name: 'skills', model_name: 'personalGoalsSkill', returns_many: true, type: 'hasMany'},
        {name: 'badges', model_name: 'personalGoalsBadge', returns_many: true, type: 'hasMany'}
    ]
}
